import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Phone } from 'lucide-react';

const navLinks = [
  { label: 'Servizi', href: '/#servizi' },
  { label: 'Prodotti', href: '/#prodotti' },
  { label: 'Lavorazioni', href: '/lavorazioni' },
  { label: 'Metodo', href: '/#metodo' },
  { label: 'Partner', href: '/partner' },
  { label: 'Recensioni', href: '/#recensioni' },
];

const DynamicIsland = ({ onOpenForm }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setIsOpen(false); }, [location]);

  const handleNavClick = (e, href) => {
    if (href.startsWith('/#')) {
      e.preventDefault();
      const id = href.replace('/#', '');
      if (location.pathname !== '/') { window.location.href = '/' + href; return; }
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <motion.nav data-testid="dynamic-island-nav" initial={{ y: -100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.6, delay: 0.2 }} className="fixed top-4 inset-x-0 z-50 flex justify-center px-4">
      <div className={`relative flex items-center justify-between w-full max-w-[340px] sm:max-w-[500px] md:max-w-[700px] lg:max-w-[1020px] px-4 sm:px-5 py-2.5 sm:py-3 rounded-full border transition-all duration-500 ${
        scrolled ? 'bg-[#0F172A]/95 backdrop-blur-xl border-white/10 shadow-2xl shadow-black/20' : 'bg-[#0F172A]/80 backdrop-blur-md border-white/10'
      }`}>
        <Link to="/" className="flex items-center shrink-0">
          <img src="https://customer-assets.emergentagent.com/job_smart-roofing-2/artifacts/7ngvxkwz_2.png" alt="Evoluzione Tetto" className="h-7 sm:h-8 lg:h-9 w-auto" />
        </Link>
        <div className="hidden lg:flex items-center gap-5">
          {navLinks.map((link) => (
            <Link key={link.label} to={link.href} onClick={(e) => handleNavClick(e, link.href)} className="text-[13px] text-gray-300 hover:text-[#FF5722] transition-colors font-medium whitespace-nowrap">{link.label}</Link>
          ))}
        </div>
        <div className="hidden lg:flex items-center gap-3 shrink-0">
          <a href="tel:800864621" className="text-[13px] text-gray-400 hover:text-white transition-colors flex items-center gap-1">
            <Phone className="w-3 h-3" /><span className="font-medium">800 864 621</span>
          </a>
          <button data-testid="nav-cta-button" onClick={onOpenForm} className="bg-[#FF5722] hover:bg-[#FF7043] text-white text-[13px] font-bold px-4 py-2 rounded-full transition-all duration-300 hover:shadow-[0_0_20px_rgba(255,87,34,0.4)] hover:-translate-y-0.5 whitespace-nowrap">Sopralluogo Gratis</button>
        </div>
        <button data-testid="mobile-menu-toggle" onClick={() => setIsOpen(!isOpen)} className="lg:hidden text-white p-1.5">
          {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div initial={{ opacity: 0, y: -10, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: -10, scale: 0.95 }} transition={{ duration: 0.2 }} className="absolute top-full mt-2 left-4 right-4 max-w-[340px] sm:max-w-[500px] mx-auto bg-[#0F172A]/95 backdrop-blur-xl border border-white/10 rounded-3xl p-5 shadow-2xl">
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link key={link.label} to={link.href} onClick={(e) => handleNavClick(e, link.href)} className="text-[15px] text-gray-300 hover:text-[#FF5722] transition-colors font-medium py-1">{link.label}</Link>
              ))}
              <hr className="border-white/10" />
              <a href="tel:800864621" className="text-gray-400 flex items-center gap-2 text-sm"><Phone className="w-4 h-4" />800 864 621</a>
              <button data-testid="mobile-cta-button" onClick={() => { setIsOpen(false); onOpenForm(); }} className="bg-[#FF5722] hover:bg-[#FF7043] text-white font-bold py-3 rounded-full text-center transition-all text-sm">Sopralluogo Gratis</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default DynamicIsland;
